import { useMap } from 'react-leaflet';
import L from 'leaflet';
import { useEffect, useRef } from 'react';

const toFiniteNumber = value => {
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
};

const collectLatLngs = (coordinates, result, coordinateOrder) => {
    if (!Array.isArray(coordinates)) return;

    const isPair =
        coordinates.length >= 2 &&
        !Array.isArray(coordinates[0]) &&
        !Array.isArray(coordinates[1]);

    if (isPair) {
        const lat =
            coordinateOrder === 'lnglat'
                ? toFiniteNumber(coordinates[1])
                : toFiniteNumber(coordinates[0]);
        const lon =
            coordinateOrder === 'lnglat'
                ? toFiniteNumber(coordinates[0])
                : toFiniteNumber(coordinates[1]);
        if (lat !== null && lon !== null) {
            result.push(L.latLng(lat, lon));
        }
        return;
    }

    coordinates.forEach(item => collectLatLngs(item, result, coordinateOrder));
};

function SetBoundsFeature({ data = null, coordinateOrder = 'latlon' }) {
    const map = useMap();
    const lastBoundsKeyRef = useRef('');

    useEffect(() => {
        if (!data || !map || !Array.isArray(data?.features)) return;
        if (data.features.length === 0) return;

        const latLngs = [];
        data.features.forEach(feature => {
            collectLatLngs(
                feature?.geometry?.coordinates,
                latLngs,
                coordinateOrder,
            );
        });
        if (latLngs.length === 0) return;

        const bounds = L.latLngBounds(latLngs);
        if (!bounds.isValid()) return;

        const boundsKey = bounds.toBBoxString();
        if (boundsKey === lastBoundsKeyRef.current) return;
        lastBoundsKeyRef.current = boundsKey;

        const isSinglePoint = latLngs.length === 1;

        if (isSinglePoint) {
            const point = latLngs[0];
            map.setView([point.lat, point.lng], map.getZoom(), {
                animate: false,
            });
            return;
        }

        map.fitBounds(bounds, { animate: false });
    }, [data, map, coordinateOrder]);

    return null;
}

export default SetBoundsFeature;
